// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8860":"css/app.6943","9624":"css/admin-app.6943"}[chunkId] + ".css";
};